import React, { useEffect, useState } from "react";
import Papa from "papaparse";
import "../styles/JobPosting.css";

const sheetURL =
"https://docs.google.com/spreadsheets/d/e/2PACX-1vTNqMbDHkByKweVMZq2IZfAdoIW9StaplR2Jovin9E1a87qTaciiQvaeE8iGsXastU-_eQTqY2sYFgs/pub?output=csv";

function JobPosting() {

const [jobs,setJobs] = useState([]);
const [search,setSearch] = useState("");
const [department,setDepartment] = useState("All");
const [location,setLocation] = useState("All");

useEffect(()=>{

Papa.parse(sheetURL,{
download:true,
header:true,
complete:(results)=>{

const active = results.data.filter(
(job)=> job.Status === "Active"
);

setJobs(active);

}

});

},[]);


const departments = ["All",...new Set(jobs.map(j=>j.Department))];
const locations = ["All",...new Set(jobs.map(j=>j.Location))];

const filteredJobs = jobs.filter(job=>{

return(

(job.JobTitle.toLowerCase().includes(search.toLowerCase())) &&
(department==="All" || job.Department===department) &&
(location==="All" || job.Location===location)

);

});

return(

<div className="jobposting-page">

{/* HERO */}

<section className="jobposting-hero">

<h1>Current Vacancies</h1>

<p>Explore career opportunities at Sahyadri Sahakari Bank Ltd.</p>

</section>


{/* FILTER BAR */}

<div className="jobposting-filterbar">

<input
type="text"
placeholder="Search Job Title..."
className="jobposting-search"
value={search}
onChange={(e)=>setSearch(e.target.value)}
/>

<select
className="jobposting-select"
value={department}
onChange={(e)=>setDepartment(e.target.value)}
>

{departments.map((dep,index)=>(
<option key={index}>{dep}</option>
))}

</select>

<select
className="jobposting-select"
value={location}
onChange={(e)=>setLocation(e.target.value)}
>

{locations.map((loc,index)=>(
<option key={index}>{loc}</option>
))}

</select>

</div>


{/* TABLE */}

<div className="jobposting-table-wrapper">

<table className="jobposting-table">

<thead>

<tr>
<th>Job Title</th>
<th>Department</th>
<th>Location</th>
<th>Qualification</th>
<th>Last Date</th>
<th>Action</th>
</tr>

</thead>

<tbody>

{filteredJobs.map((job,index)=>(

<tr key={index}>

<td data-label="Job Title">{job.JobTitle}</td>

<td data-label="Department">{job.Department}</td>

<td data-label="Location">{job.Location}</td>

<td data-label="Qualification">{job.Qualification}</td>

<td data-label="Last Date">{job.LastDate}</td>

<td data-label="Action">

<a
href={job.ApplyLink}
target="_blank"
rel="noopener noreferrer"
className="jobposting-applybtn"
>

Apply

</a>

</td>

</tr>

))}

</tbody>

</table>

</div>
</div>

);

}

export default JobPosting;